import { ReactNode } from "react";
import * as S from "../styles";
import { Text } from "@components/common/ui/Text";
import { useAffiliateData } from "@hooks/affiliates/affiliate/useAffiliateData";
interface ProductPresentationProps {
  children: ReactNode;
}

export default function ProductPresentation({ children }: ProductPresentationProps) {
  const { data } = useAffiliateData();
  const affiliatesEnabled = data?.affiliatesEnabled;

  return (
    <S.ContentCard noMarginBottom={affiliatesEnabled} flex>
      <S.Title size="xxx-large" weight="bold" color="blackGray">
        {affiliatesEnabled
          ? " Você foi convidado a se tornar afiliado desse produto e ganhar dinheiro com ele"
          : "A afiliação para este produto esta desativada no momento"}
      </S.Title>
      {children}
    </S.ContentCard>
  );
}
